// 默认请求的语言
export var DEFAULT_LANG = 'en';

// 缓存的CDN币对列表 key
export var SPOT_SYMBOLS_DATA_COMMON = 'SPOT_SYMBOLS_DATA_COMMON';

// 缓存的symbol_list key
export var SPOT_SYMBOLS_DATA = 'SPOT_SYMBOLS_DATA';

// 接口默认超时时间，单位：ms
export var TIMEOUT = 8e3;

// 接口重试的最大次数
export var MAX_RETRY_TIMES = 0;

// 接口重试的最小间隔，采用backoff方式，单位：ms
export var MIN_RETRY_INTERVAL = 2e3;

// 接口重试的最大间隔，采用backoff方式，单位：ms
export var MAX_RETRY_INTERVAL = 4e3;

// 现货交易对列表接口，2024.7.2改造，从v2版本拆分成"ALL"和"v3"两个接口，分别对应CDN缓存的币对列表和用户相关的币对列表，需要两个接口合并后，才能得到完整的币对列表和字段
export var SYMBOL_LIST_API = {
  ALL: '/spot/api/basic/symbol_list_all',
  // 获取CDN缓存的币对列表（非用户相关的币对和字段，非全量字段）
  V2: '/spot/api/basic/symbol_list_v2',
  // 获取symbols列表，全量字段，用作兜底逻辑
  V3: '/spot/api/basic/symbol_list_v3' // 获取和用户相关的币对列表和字段，非全量字段
};

// 默认错误提示
export var REQUEST_ERROR_TOAST = 'Request failed. Please try again later.';

/**
 * symbol_list v1 -> v2 接口数据结构映射表
 * https://uponly.larksuite.com/wiki/EF7KwQcV9iMtKXkwelluRFCOsIc
 * https://api2.unify-test-2.bybit.com/spot/api/basic/symbol_list_v2
 * https://api2.unify-test-2.bybit.com/spot/api/basic/symbol_list
 * 以下注释的代表v1版本有，v2版本已删除的字段
 */
export var API_KEY_MAP = {
  // oi: 'orgId',
  // ei: 'exchangeId',
  // en: 'exchangeName',
  si: 'symbolId',
  sn: 'symbolName',
  bti: 'baseTokenId',
  btn: 'baseTokenName',
  qti: 'quoteTokenId',
  qtn: 'quoteTokenName',
  bp: 'basePrecision',
  qp: 'quotePrecision',
  miq: 'minTradeQuantity',
  mia: 'minTradeAmount',
  mip: 'minPricePrecision',
  dm: 'digitMerge',
  // ct: 'canTrade',
  // f: 'favorite',
  // cs: 'customOrder',
  // is: 'indexShow',
  // iso: 'indexShowOrder',
  // bto: 'baseTokenOption',
  // btf: 'baseTokenFutures',
  // btm: 'baseTokenMargin',
  // fli: 'firstLevelUnderlyingId',
  // fln: 'firstLevelUnderlyingName',
  // sli: 'secondLevelUnderlyingId',
  // sln: 'secondLevelUnderlyingName',
  // xt: 'indexToken',
  // ir: 'isReverse',
  // ia: 'isAggregate',
  // iro: 'indexRecommendOrder',
  ss: 'showStatus',
  // c: 'category',
  // am: 'allowMargin',
  // li: 'labelId',
  l: 'label',
  // sg: 'symbolTag',
  // sc: 'symbolConfig',
  ap: 'allowPlan',
  maq: 'maxTradeQuantity',
  maa: 'maxTradeAmount',
  nv: 'noticeVisible',
  st: 'symbolType',
  lul: 'ltUnderlying',
  ld: 'ltDirection',
  t: 'tags',
  tfn: 'tokenFullName',
  iu: 'iconUrl',
  ot: 'onlineTime',
  m: 'mark',
  qtr: 'quoteTokenLeverageRatio',
  btr: 'baseTokenLeverageRatio',
  le: 'loanEnabled',
  it: 'isTest',
  bb: 'isBanBuy',
  bs: 'isBanSell',
  idu: 'iconDayUrl',
  ts: 'tradeStatus',
  zft: 'zeroFeeType',
  lpp: 'limitOrderPriceLimitPercentage',
  mpp: 'marketOrderPriceLimitPercentage',
  v: 'volume'
};